module.exports = __webpack_public_path__ + "img/icon-white-35.9ae475c6.svg";